import { createContext, useContext } from "react";

type NavigationOverlayState = {
  activeOverlay: string | null;
  openOverlay: (id: string) => void;
  closeOverlay: (id?: string) => void;
};

export const NavigationOverlayContext =
  createContext<NavigationOverlayState | null>(null);

export const useNavigationOverlay = () => {
  const context = useContext(NavigationOverlayContext);
  if (!context) {
    throw new Error("useNavigationOverlay requires NavigationOverlayProvider");
  }
  return context;
};

export const NavigationOverlayPresentationContext = createContext<
  "popover" | "panel"
>("popover");

export const useNavigationOverlayPresentation = () =>
  useContext(NavigationOverlayPresentationContext);
